// Session AU, Item 3: a clickable sortable table header cell for the standalone office list tables
// (Contracts, Defects, Service records, Projects, Renewals). Clicking cycles asc -> desc -> default;
// the ACTIVE sort shows its direction arrow in ELE light blue (#00C4FF), an inactive sortable column a
// muted hint (no "sorted" indicator when cleared). Drives, and reads, the useSortableColumn hook so the
// behaviour matches the RegisterPage registers exactly.
import type { SortState } from "../lib/useSortableColumn";

export function SortableHeader({
  label,
  colKey,
  sort,
  onToggle,
  align,
  className,
}: {
  label: string;
  colKey: string;
  sort: SortState;
  onToggle: (key: string) => void;
  align?: "left" | "right";
  className?: string;
}) {
  const active = sort.sortKey === colKey;
  const arrow = active ? (sort.sortDir === "asc" ? "▲" : "▼") : "⇅";
  return (
    <th
      className={`px-3 py-2${align === "right" ? " text-right" : ""}${className ? ` ${className}` : ""}`}
      aria-sort={active ? (sort.sortDir === "asc" ? "ascending" : "descending") : "none"}
    >
      {/* Deliberately uppercase: this is COLUMN-HEADER text (the thead eyebrow treatment the
          design system uppercases via CSS on static th cells), not a button label -- the AGY
          sentence-case sweep excludes it so sortable and static headers stay identical. */}
      <button
        type="button"
        onClick={() => onToggle(colKey)}
        aria-label={`Sort by ${label}`}
        className={`inline-flex max-w-full items-center gap-1 font-menu uppercase tracking-widest transition hover:text-ele-green${align === "right" ? " flex-row-reverse" : ""}`}
      >
        <span className="min-w-0 truncate">{label}</span>
        <span aria-hidden className={`text-[10px] ${active ? "text-ele-blue" : "text-ele-body opacity-50"}`}>
          {arrow}
        </span>
      </button>
    </th>
  );
}
